var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_684_15793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3915 15.3925L17.0832 14.1667C17.5351 14.0327 18.0172 14.0408 18.4644 14.1898C18.9115 14.3389 19.3021 14.6217 19.5832 15C9.39234 20.0942 12.6898 20.0642 3.74984 17.0833L0.416504 19.1667",
    stroke: "#FF8053",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9165 15.8333H12.4998C12.6217 15.8552 12.747 15.8501 12.8667 15.8183C12.9864 15.7866 13.0977 15.7289 13.1927 15.6494C13.2877 15.57 13.3641 15.4706 13.4166 15.3584C13.469 15.2462 13.4962 15.1239 13.4962 15C13.4962 14.8761 13.469 14.7538 13.4166 14.6416C13.3641 14.5294 13.2877 14.43 13.1927 14.3506C13.0977 14.2711 12.9864 14.2134 12.8667 14.1817C12.747 14.1499 12.6217 14.1448 12.4998 14.1667H9.99984C9.01207 13.1475 7.6682 12.5503 6.24984 12.5H3.74984L0.416504 14.1667",
    stroke: "#FF8053",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7959 5.95766C7.7959 6.63058 7.92844 7.2969 8.18595 7.9186C8.44347 8.54029 8.82091 9.10517 9.29673 9.581C9.77256 10.0568 10.3374 10.4343 10.9591 10.6918C11.5808 10.9493 12.2472 11.0818 12.9201 11.0818C13.593 11.0818 14.2593 10.9493 14.881 10.6918C15.5027 10.4343 16.0676 10.0568 16.5434 9.581C17.0192 9.10517 17.3967 8.54029 17.6542 7.9186C17.9117 7.2969 18.0442 6.63058 18.0442 5.95766C18.0442 5.28475 17.9117 4.61842 17.6542 3.99673C17.3967 3.37504 17.0192 2.81015 16.5434 2.33433C16.0676 1.85851 15.5027 1.48106 14.881 1.22355C14.2593 0.966037 13.593 0.833496 12.9201 0.833496C12.2472 0.833496 11.5808 0.966037 10.9591 1.22355C10.3374 1.48106 9.77256 1.85851 9.29673 2.33433C8.82091 2.81015 8.44347 3.37504 8.18595 3.99673C7.92844 4.61842 7.7959 5.28475 7.7959 5.95766Z",
    stroke: "#FF8053",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9199 3.33333V2.5",
    stroke: "#FF8053",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 3.3335H12.476C12.2163 3.33368 11.9648 3.42419 11.7646 3.58952C11.5644 3.75485 11.428 3.98469 11.3787 4.23961C11.3295 4.49453 11.3704 4.75866 11.4946 4.98668C11.6188 5.2147 11.8184 5.39241 12.0593 5.48933L13.7793 6.17766C14.0202 6.27458 14.2198 6.45229 14.344 6.68031C14.4682 6.90833 14.5091 7.17246 14.4599 7.42738C14.4106 7.6823 14.2741 7.91214 14.0739 8.07747C13.8737 8.2428 13.6223 8.33331 13.3626 8.3335H11.6668",
    stroke: "#FF8053",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9199 9.16683V8.3335",
    stroke: "#FF8053",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_684_15793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHIcon6);
export default __webpack_public_path__ + "static/media/hIcon6.0f4d3331f2e3ab5bc5e1ea9476cd7294.svg";
export { ForwardRef as ReactComponent };